import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import { CpuChipIcon } from "@heroicons/react/24/outline";
import { toast } from "react-toastify";
import { postDistributeSeats } from "../../../services/olympiad/teamMemberService";

export default function TeamPageHeader({ isExamCenterAdmin }) {
  const [t] = useTranslation();

  const handleDistribute = () => {
    const toastId = "distribute-seats";
    if (toast.isActive(toastId)) return;

    toast(
      <div className="flex flex-col gap-3 pt-1">
        <p className="font-medium">
          {t(
            "admin.distribute_students_confirm",
            "Distribute students to classrooms?"
          )}
        </p>
        <p className="text-sm text-gray-600">
          {t(
            "admin.distribute_students_warning",
            "Caution: seats will be assigned automatically."
          )}
        </p>
        <div className="flex justify-end gap-2">
          <Button
            text={t("buttons.cancel")}
            color="secondary"
            onClick={() => toast.dismiss(toastId)}
          />
          <Button
            text={t("buttons.confirm", "Confirm")}
            color="primary"
            onClick={() => {
              postDistributeSeats()
                .then(() => {
                  toast.dismiss(toastId);
                  toast.success(
                    t(
                      "admin.distribute_students_success",
                      "Distribution started"
                    )
                  );
                })
                .catch((err) => {
                  toast.dismiss(toastId);
                  toast.error(
                    err.response?.data?.detail ||
                      t(
                        "admin.distribute_students_error",
                        "Failed to distribute"
                      )
                  );
                });
            }}
          />
        </div>
      </div>,
      { hideProgressBar: true, toastId }
    );
  };

  return (
    <div className="mb-4 flex items-center justify-between">
      <h1 className="text-2xl font-bold">{t("admin.teams")}</h1>
      {!isExamCenterAdmin && (
        <Button
          Icon={CpuChipIcon}
          text={t("admin.distribute_students_to_classrooms")}
          onClick={handleDistribute}
          color="primary"
        />
      )}
    </div>
  );
}
